import {compact} from '@benchling/js-utils';
import {css} from 'aphrodite';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {AvatarShape, AvatarSize} from 'ui-library/avatar/AvatarConstants';
import {AvatarWithName} from 'ui-library/avatar/AvatarWithName';
import * as DateUtil from 'util/DateUtil';

import FormattedTextField from '../fields/FormattedTextField';
import getStudiesRowContent from '../fields/getStudiesRowContent';
import SourceTasksAndOutputsField from '../fields/SourceTasksAndOutputsField';
import {
  getProcessTaskDetailsLabels,
  PROCESS_TASK_DETAILS_PAGE_STYLES,
} from '../ProcessTaskDetailsPageConstants';
import {ProcessTaskDetailsRowContent, ProcessTaskGql} from '../ProcessTaskDetailsPageConstants';

export function getProceduresTaskMetadataRows(
  processTask: ProcessTaskGql
): Array<ProcessTaskDetailsRowContent> {
  const processTaskDetailsLabels = getProcessTaskDetailsLabels();
  return compact([
    {
      label: processTaskDetailsLabels.ID,
      component: <FormattedTextField text={processTask.humanId} />,
    },
    {
      label: processTaskDetailsLabels.CREATOR,
      component: (
        <AvatarWithName
          avatarInfo={processTask.creator}
          size={AvatarSize.XXSMALL}
          shape={AvatarShape.CIRCLE}
          showTooltip={true}
        />
      ),
    },
    {
      label: processTaskDetailsLabels.CREATED,
      component: <FormattedTextField text={DateUtil.readableTime(processTask.createdAt)} />,
    },
    {
      label: processTaskDetailsLabels.MODIFIED,
      component: (
        <span className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.rowHeight)}>
          {DateUtil.readableTime(processTask.modifiedAt)}
        </span>
      ),
    },
    processTask.rootTask != null
      ? {
          label: processTaskDetailsLabels.SOURCES,
          component: <SourceTasksAndOutputsField processTask={processTask} />,
        }
      : null,
    BenchlingConfig.STUDIES_ENABLE ? getStudiesRowContent(processTask) : null,
  ]);
}
